export default __webpack_public_path__ + "static/220803_天下布魔更新內容預告_kr-51eadd4c69ed2d158213f979f5dfdef0.webp";